import { create } from '@thoughtspot/logger';
import { DispatchChartInteractionType, } from '@thoughtspot/ts-chart-sdk';
import { getIframeAdjustedCoords } from '../common/utils/helper';
import { convertPointValToContextMenuInputValue } from '../context-menu-events/util';
const logger = create('chart-to-ts > dispatch-chart-interaction > trigger');
const interactionTypeToDOMEvent = {
    [DispatchChartInteractionType.PointerDown]: 'mousedown',
};
export const handleTriggerOnParent = (type, eventPayload, iFrameWindow) => {
    const { clientX: adjustedX, clientY: adjustedY } = getIframeAdjustedCoords(iFrameWindow, eventPayload.event.clientX, eventPayload.event.clientY);
    const domEventName = interactionTypeToDOMEvent[type] || type.toLowerCase();
    const syntheticEvent = new PointerEvent(domEventName, {
        clientX: adjustedX,
        clientY: adjustedY,
        bubbles: true,
        cancelable: true,
    });
    const targetElement = document.elementFromPoint(adjustedX, adjustedY);
    if (targetElement) {
        targetElement.dispatchEvent(syntheticEvent);
    }
    else {
        logger.warn(`No target element found at (${adjustedX}, ${adjustedY})`);
    }
    logger.info(`Dispatched synthetic ${domEventName} at (${adjustedX}, ${adjustedY})`);
};
export const handleDispatchEmbedEvent = (payload, columns, callbacks) => {
    switch (payload.type) {
        case DispatchChartInteractionType.VizPointRightClick:
            if (!callbacks.onPointRightClick) {
                logger.warn('onPointRightClick callback not provided');
                return;
            }
            callbacks.onPointRightClick(convertPointValToContextMenuInputValue(payload.eventPayload.clickedPoint, columns));
            break;
        case DispatchChartInteractionType.VizPointClick:
            if (!callbacks.onPointClick) {
                logger.warn('onPointClick callback not provided');
                return;
            }
            callbacks.onPointClick(convertPointValToContextMenuInputValue(payload.eventPayload.clickedPoint, columns));
            break;
        case DispatchChartInteractionType.VizPointDoubleClick:
            if (!callbacks.onPointDoubleClick) {
                logger.warn('onPointDoubleClick callback not provided');
                return;
            }
            callbacks.onPointDoubleClick(convertPointValToContextMenuInputValue(payload.eventPayload.clickedPoint, columns));
            break;
        default:
            logger.warn(`No DispatchEmbedEvent handler for type: ${payload.type}`);
    }
};
//# sourceMappingURL=trigger-event.js.map